const testimonials = [
  {
    name: "Alexandre Salice",
    role: "CEO, TechBridge Brasil",
    country: "🇧🇷 Brasil",
    rating: 5,
    text: "Tenho várias empresas aqui, principalmente LLC para software, e já recomendei a Globalfy para vários amigos. WhatsApp disponível, educados e prestimosos. A empresa completa que necessitei para meu negócio americano. Eles realmente cumprem o que prometem!",
    avatar: "https://public.readdy.ai/ai/img_res/234f121b28cb4be0b2fd81b122dcc6be.jpg",
  },
  {
    name: "Rafaela Mendonça",
    role: "Fundadora, Digital Nomads Hub",
    country: "🇧🇷 Brasil",
    rating: 5,
    text: "Como nômade digital, precisava de uma empresa nos EUA para receber pagamentos internacionais. A Globalfy tornou tudo incrivelmente simples! Em menos de uma semana já tinha minha LLC funcionando com conta bancária aberta.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20Brazilian%20woman%20entrepreneur%20founder%20smiling%20confident%20light%20background%20clean%20minimal%20portrait%20photo&width=80&height=80&seq=avatar-rafa-01&orientation=squarish",
  },
  {
    name: "Carlos Espinoza",
    role: "Diretor, Latam Ventures",
    country: "🇲🇽 México",
    rating: 5,
    text: "Excelente servicio. El equipo habla español perfectamente y conocen muy bien los procesos para empresas de Latinoamérica. En menos de una semana ya tenía mi empresa registrada y lista para operar.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20Latin%20male%20business%20director%20smiling%20confident%20light%20background%20clean%20minimal%20portrait&width=80&height=80&seq=avatar-carlos-01&orientation=squarish",
  },
  {
    name: "Pedro Almada",
    role: "CTO, CloudSync PT",
    country: "🇵🇹 Portugal",
    rating: 5,
    text: "Estávamos a expandir para os EUA e a Globalfy foi fundamental. Suporte em português europeu, processos claros e sem surpresas. Recomendo vivamente a qualquer empresa europeia que queira operar no mercado americano.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20Portuguese%20male%20tech%20founder%20smiling%20confident%20light%20background%20clean%20minimal%20portrait%20photo&width=80&height=80&seq=avatar-pedro-01&orientation=squarish",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="depoimentos" className="bg-[#f7f7f4] py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[#2563eb] text-sm font-semibold tracking-wider uppercase">Avaliações reais</span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#0f2044] mt-2 mb-4">
            Avaliado como{" "}
            <span className="text-[#2563eb]">excelente</span>{" "}
            por fundadores do mundo todo
          </h2>
          <p className="text-gray-500 text-base max-w-lg mx-auto">
            Avaliações verificadas de empreendedores que confiam na ZB Advisor para operar nos EUA.
          </p>


        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {testimonials.map((t, idx) => (
            <div key={idx} className="bg-white rounded-2xl p-6 border border-gray-100">
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, s) => (
                  <i key={s} className="ri-star-fill text-[#fbbf24] text-sm" />
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-5">&quot;{t.text}&quot;</p>
              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover object-top"
                />
                <div>
                  <p className="text-[#0f2044] font-semibold text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.role} · {t.country}</p>
                </div>
              </div>
            </div>
          ))}
        </div>


      </div>
    </section>
  );
}
